import { Box, Container, Grid, Typography } from '@mui/material';
import useTranslate from '../../Hooks/useTranslate';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { CdsColorBrandBananabread80 } from '@cegid/design-tokens';
import mountains from 'Theme/assets/images/mountains.png';

interface Props {
  type: 'removedProfile';
}

function PageSuccess({ type }: Readonly<Props>) {
  const ts = useTranslate();

  return (
    <Container
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px',
      }}
    >
      <Grid container flexDirection="column" alignItems="left">
        <Grid item>
          <AutoAwesomeIcon style={{ fontSize: '2em', color: CdsColorBrandBananabread80 }} />
          <Typography
            component="h1"
            sx={{ fontSize: { xs: '2em', md: '4rem'}, fontWeight: 300, textAlign: 'left', maxWidth: '850px' }}
            paragraph
          >
            {type === 'removedProfile' &&
              ts(
                'page.userProfile.personalInformations.deleteMyProfile.deleteMeSuccess'
              )}
          </Typography>
        </Grid>
        <Box height={20} />
        <Grid item>
          {type === 'removedProfile' && (
            <>
              <Typography variant="h5" paragraph sx={{ fontSize: { xs: '1.2em', md: '2.2em'}, fontWeight: 100, textAlign: 'flex-start'}}>
                {ts('successPage.youAreDisconnected')}
              </Typography>
              <Typography variant="body2" component="div" pt={4} sx={{maxWidth: 500}}>
                {ts('successPage.noMoreAccess')}
              </Typography>
            </>
          )}
        </Grid>
        
      </Grid>
      <img src={mountains} alt="paper mountains" style={{ maxWidth: '100%',
        maxHeight: '100%',
        position: 'absolute',
        bottom: 0,
        right: 0,
        zIndex: -1 }} />
    </Container>
  );
}

export default PageSuccess;
